import {
  FaGithub,
  FaLinkedin,
  FaWhatsapp,
  FaEnvelope,
  FaArrowUp,
} from "react-icons/fa";

const links = [
  "Home",
  "About",
  "Skills",
  "Services",
  "Projects",
  "Experience",
  "Contact",
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#050816] pt-[50px]">

      {/* Background */}

      <div className="absolute left-0 top-0 h-72 w-72 rounded-full bg-blue-600/10 blur-[120px]" />

      <div className="container py-24">

        <div className="grid gap-16 lg:grid-cols-4">

          {/* Brand */}

          <div>

            <a
              href="#home"
              className="text-4xl font-black"
            >
              MQ
              <span className="text-blue-500">.</span>
            </a>

            <p className="mt-8 leading-8 text-slate-400">

              Senior Frontend Developer specializing in
              React, Next.js, WordPress and modern web
              technologies.

              Building high-performance websites
              with beautiful user experiences.

            </p>

          </div>

          {/* Navigation */}

          <div>

            <h3 className="text-xl font-bold mb-8">

              Navigation

            </h3>

            <div className="flex flex-col gap-4">

              {links.map((item) => (

                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className="text-slate-400 hover:text-blue-400 duration-300"
                >

                  {item}

                </a>

              ))}

            </div>

          </div>

          {/* Services */}

          <div>

            <h3 className="text-xl font-bold mb-8">

              Expertise

            </h3>

            <div className="flex flex-col gap-4 text-slate-400">

              <span>React Development</span>

              <span>Next.js Development</span>

              <span>WordPress</span>

              <span>WooCommerce</span>

              <span>Headless CMS</span>

              <span>Performance Optimization</span>

            </div>

          </div>

          {/* Contact */}

          <div>

            <h3 className="text-xl font-bold mb-8">

              Connect

            </h3>

            <div className="space-y-5">

              <a
                href="mailto:me@moobeenquader.com"
                className="flex items-center gap-3 text-slate-400 hover:text-blue-400"
              >
                <FaEnvelope />

                me@moobeenquader.com

              </a>

              <div className="flex gap-4 pt-6">

                <a
                  href="https://github.com/"
                  className="h-12 w-12 rounded-full border border-white/10 bg-white/5 flex items-center justify-center hover:bg-blue-600 transition"
                >
                  <FaGithub />
                </a>

                <a
                  href="https://www.linkedin.com/in/moobeen-quader-a40099b1"
                  className="h-12 w-12 rounded-full border border-white/10 bg-white/5 flex items-center justify-center hover:bg-blue-600 transition"
                >
                  <FaLinkedin />
                </a>

                <a
                  href="https://api.whatsapp.com/send?phone=923322351994&&text=Hi%20there/"
                  className="h-12 w-12 rounded-full border border-white/10 bg-white/5 flex items-center justify-center hover:bg-green-600 transition"
                >
                  <FaWhatsapp />
                </a>

              </div>

            </div>

          </div>

        </div>

        {/* Bottom */}

        <div className="mt-20 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 lg:flex-row">

          <p className="text-slate-500">

            © {new Date().getFullYear()} Moobeen Quader.
            All rights reserved.

          </p>

          <a
            href="#home"
            className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 transition hover:bg-blue-700"
          >

            <FaArrowUp />

          </a>

        </div>

      </div>

    </footer>
  );
}